"use client";

import type { MuxPlayerRefAttributes } from "@mux/mux-player-react";
import type { Ref, RefCallback } from "react";
import { useCallback, useEffect, useRef } from "react";

import { observeWayflyerControlBarLayout } from "./wayflyer-control-bar";

export function useWayflyerControlBarRef<
  T extends MuxPlayerRefAttributes = MuxPlayerRefAttributes,
>() {
  const cleanupRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    return () => {
      cleanupRef.current?.();
      cleanupRef.current = null;
    };
  }, []);

  return useCallback((node: T | null) => {
    cleanupRef.current?.();
    cleanupRef.current = null;

    if (node) {
      cleanupRef.current = observeWayflyerControlBarLayout(node);
    }
  }, []);
}

export function mergePlayerRefs<T>(
  ...refs: Array<Ref<T> | undefined>
): RefCallback<T> {
  return (value) => {
    for (const ref of refs) {
      if (!ref) continue;
      if (typeof ref === "function") {
        ref(value);
      } else {
        ref.current = value;
      }
    }
  };
}
